export default __webpack_public_path__ + "static/media/studyMaterialIcon.3392ba52.svg";